import axios from "axios";
import { getBackendUrl } from "@src/utils/getNodeUrl";

const transactionsService = {
  getTransactions: async (
    params: Array<[string, string | number | boolean]>
  ) => {
    const search =
      params.length > 0
        ? `?${params.map(([k, v]) => `${k}=${String(v)}`).join("&")}`
        : "";
    const url =
      `${getBackendUrl()}/api/v1/transactions` + search;
    console.log('[transactionsService] Using backend URL:', getBackendUrl());
    const { data } = await axios.get(url);
    return data;
  }
};

export default transactionsService;
